import { NgModule } from '@angular/core';
import { MealPlanPage } from 'pages/meal-plan/meal-plan';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [MealPlanPage],
    imports: [PagesModule, ComponentsModule],
    exports: [MealPlanPage]
})
export class MealPlanPageModule {}
